import styled from '@emotion/styled';
import { Button } from '@lbcamden/lib-react';

export const ReviewDateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const ReviewDateOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(3)};

  ${Button} {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
